export function formatMessageHtml(text: string | undefined | null): string {
  const raw = String(text || '');
  // Escape HTML to avoid injection
  const escapeHtml = (s: string) => s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  let safe = escapeHtml(raw);

  // Linkify emails first
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
  safe = safe.replace(emailRegex, (email) => {
    return `<a href="mailto:${email}" target="_blank" rel="noopener noreferrer">${email}</a>`;
  });

  // Linkify markdown-style [text](url)
  const mdLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
  safe = safe.replace(mdLinkRegex, (_, text, url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${escapeHtml(text)}</a>`;
  });

  // Linkify URLs (http, https, www)
  const urlRegex = /(?:https?:\/\/|www\.)[^\s<]+/gi;
  safe = safe.replace(urlRegex, (url) => {
    const href = url.startsWith('www.') ? `http://${url}` : url;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  // @gemma — wygląd jak hiperlink (kolor + podkreślenie), bez fałszywego href
  safe = safe.replace(
    /@gemma\b/gi,
    (full) =>
      `<span class="internal-chat-mention-gemma" style="color:#3F3FDC;font-weight:600;text-decoration:underline;text-underline-offset:2px;cursor:default">${full}</span>`
  );

  // Pozostałe wzmianki @user — pogrubienie (bez ponownego łapania @gemma)
  safe = safe.replace(/@(?!gemma\b)([a-z0-9._-]{2,})/gi, '<b>@$1</b>');

  // Preserve new lines
  safe = safe.replace(/\n/g, '<br/>');

  return safe;
}


